export default "__VITE_ASSET__yiEd6ecP__"